import { Check, RotateCcw, X } from 'lucide-react'
import IconButton from '../../components/IconButton'
import TextField from '../../components/TextField'
import { common as C } from './strings'

/*
 * The edits بيانات الإعدادات makes happen IN THE ROW: the pencil turns the row's cells into
 * fields, and its Save and Cancel take the pencil's place. Nothing opens over the table.
 */

/**
 * A field typed into the cell it edits. Enter saves, Escape puts the row back. A refusal
 * is said under the field, where the eye already is — not in a dialog.
 */
export function InlineInput({
  value,
  onChange,
  onSave,
  onCancel,
  label,
  dir,
  mono = false,
  autoFocus = false,
  error = '',
  busy = false,
}) {
  return (
    <span className="sk-inline">
      <TextField
        value={value}
        onChange={onChange}
        dir={dir}
        autoFocus={autoFocus}
        aria-label={label}
        invalid={Boolean(error)}
        disabled={busy}
        autoComplete="off"
        className={`sk-inline__input${mono ? ' is-mono' : ''}`}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            event.preventDefault()
            onSave()
          }
          if (event.key === 'Escape') {
            event.preventDefault()
            onCancel()
          }
        }}
      />
      {error && (
        <span className="sk-inline__error" role="alert">
          <bdi>{error}</bdi>
        </span>
      )}
    </span>
  )
}

/**
 * The open row's own Save and Cancel, where its pencil was. `onReset` adds a third: put
 * the field back to the key's default — the most common edit on this screen.
 */
export function InlineActions({ canSave, busy = false, onSave, onCancel, onReset, resetLabel }) {
  return (
    <span className="sk-inline__actions">
      <IconButton icon={Check} tone="success" label={C.save} onClick={onSave} disabled={!canSave || busy} />
      {onReset && (
        <IconButton icon={RotateCcw} tone="primary" label={resetLabel} onClick={onReset} disabled={busy} />
      )}
      <IconButton icon={X} tone="primary" label={C.reset} onClick={onCancel} disabled={busy} />
    </span>
  )
}
